import { UnitTransferDocumentFulfilmentModeEnumType } from '__generated__/graphql';

export default function unitTransferDocumentFulfilmentModeToReadable(
  mode: UnitTransferDocumentFulfilmentModeEnumType
): string {
  switch (mode) {
    case UnitTransferDocumentFulfilmentModeEnumType.InvestorUpload:
      return 'Investor Upload';
    case UnitTransferDocumentFulfilmentModeEnumType.AdminUpload:
      return 'Admin Upload';
    case UnitTransferDocumentFulfilmentModeEnumType.Signature:
      return 'Fulfilled via Signature';
    default:
      return mode;
  }
}
